export default "__VITE_ASSET__c6ae6bbd__"